export const icAccountClientData = require("images/ic_account_client_data.svg");
export const icAccountDiscounts = require("images/ic_account_discounts.svg");
export const icAccountPlanTactico = require("images/ic_account_plan_tactico.svg");
export const icAprobMan = require("images/ic_aprob_man.svg");
export const icAprobWoman = require("images/ic_aprob_woman.svg");
export const icAttachDoc = require("images/ic_attach_doc.svg");
export const icBack = require("images/ic_back.svg");
export const icBattery = require("images/ic_battery.svg");
export const icBell = require("images/ic_bell.png");
export const icBtu = require("images/ic_btu.svg");
export const icSettings = require("images/ic_settings.svg");
export const icCar = require("images/ic_car.svg");
export const icChevronDownFilled = require("images/ic_chevron_down_filled.svg");
export const icClose = require("images/ic_close.svg");
export const icMenu = require("images/ic_menu.svg");
export const icMore = require("images/ic_more.svg");
export const icMoto = require("images/ic_moto.svg");
export const icProducts = require("images/ic_products.svg");
export const icQuote = require("images/ic_quote.svg");
export const icOrders = require("images/ic_orders.svg");
export const icAccountStates = require("images/ic_account_states.svg");
export const icInvoice = require("images/ic_invoice.svg");
export const icSearch = require("images/ic_search.svg");
export const icSearch2 = require("images/ic_search2.svg");
export const icSupport = require("images/ic_support.svg");
export const icSignOff = require("images/ic_sign_off.svg");
export const icPlus = require("images/ic_plus.svg");
export const icMinus = require("images/ic_minus.svg");
export const icTrash = require("images/ic_trash.svg");
export const icTrash2 = require("images/ic_trash2.svg");
export const icMarker = require("images/ic_marker.svg");
export const icTruck = require("images/ic_truck.svg");
export const icNext = require("images/ic_next.svg");
export const icInvoiceDownload = require("images/ic_invoice_download.svg");
export const icGuideDownload = require("images/ic_guide_download.svg");
export const icUserWithBack = require("images/ic_user_with_back.svg");
export const icSend = require("images/ic_send.svg");
export const icDownload = require("images/ic_download.svg");
export const icDownload2 = require("images/ic_download2.svg");
export const icEye = require("images/ic_eye.svg");
export const icEdit = require("images/ic_edit.svg");
export const icPhone = require("images/ic_phone.svg");
export const icShoppingCartClear = require("images/ic_shopping_cart_clear.svg");
export const icUserHeadPhones = require("images/ic_user_headphones.png");
export const icHome = require("images/ic_home.png");
export const icCheck = require("images/ic_check.svg");
export const imgBBVA = require("images/img_bbva.png");
export const imgBCP = require("images/img_bcp.png");
export const imgBN = require("images/img_bn.png");
export const imgCaja = require("images/img_caja.png");
export const imgIbk = require("images/img_ibk.png");
export const icRequirement = require("images/ic_requirement.png");
export const icCalendar = require("images/ic_calendar.svg");
export const icCalendar2 = require("images/ic_calendar2.svg");
export const imgCalendar = require("images/img_calendar.png");
export const icClock = require("images/ic_clock.svg");
export const icPhoneOutline = require("images/ic_phone_outline.svg");
export const icBtuPrice = require("images/ic_btu_price.svg");
export const icDeliveryStep1 = require("images/ic_delivery_step1.svg");
export const icDeliveryStep2 = require("images/ic_delivery_step2.svg");
export const icDeliveryStep3 = require("images/ic_delivery_step3.svg");
export const icDeliveryCar = require("images/ic_delivery_car.svg");
export const icXInsideCircle = require("images/ic_x_inside_circle.svg");
export const icDot = require("images/ic_dot.svg");
export const icArrowSubmenu = require("images/ic_arrow_submenu.svg");
export const icArrowSubmenuLine = require("images/ic_arrow_submenu_line.svg");
export const imgArrowSubmenuLine = require("images/img_arrow_submenu_line.png");
export const imgArrowSubmenu = require("images/img_arrow_submenu.png");
export const imgBTUSaleSuccess = require("images/img_btu_sale_success.png");
export const imgClock = require("images/img_clock.png");
export const imgHomeOutline = require("images/img_home_outline.png");
export const icCapEnerjet = require("images/ic_cap_enerjet.svg");
export const icInvitation = require("images/ic_invitation.svg");
export const icWheel = require("images/ic_wheel.svg");
export const imgBatteryLevel = require("images/img_battery_level.png");
export const imgButtonGame = require("images/img_button_game.png");
export const imgScratchCover = require("images/img_scratch_cover.png");
export const imgScratchGameBg = require("images/img_scratch_game_bg.png");
export const imgScratchGameMini = require("images/img_scratch_game_mini.png");
export const imgSlotsGameBg = require("images/img_slots_game_bg.png");
export const imgSlotsGameMini = require("images/img_slots_game_mini.png");
export const imgWheelCenter = require("images/img_wheel_center.png");
export const imgWheelFoot = require("images/img_wheel_foot.png");
export const imgWheelGameBg = require("images/img_wheel_game_bg.png");
export const imgWheelGameMini = require("images/img_wheel_game_mini.png");
export const imgWheelName = require("images/img_wheel_name.png");
export const imgWheel = require("images/img_wheel.png");
export const imgWheelPrize15p = require("images/img_wheel_prize_15p.png");
export const imgWheelPrizeCup = require("images/img_wheel_prize_cup.png");
export const imgWheelPrizeHincha = require("images/img_wheel_prize_hincha.png");
export const imgWheelPrizeJacket = require("images/img_wheel_prize_jacket.png");
export const imgWheelPrizeNothing = require("images/img_wheel_prize_nothing.png");
export const imgWheelPrizeTshirt = require("images/img_wheel_prize_tshirt.png");

export default {
	icAccountClientData,
	icAccountDiscounts,
	icAccountPlanTactico,
	icAprobMan,
	icAprobWoman,
	icAttachDoc,
	icBack,
	icBattery,
	icBell,
	icBtu,
	icSettings,
	icCar,
	icChevronDownFilled,
	icClose,
	icMenu,
	icMore,
	icMoto,
	icProducts,
	icQuote,
	icOrders,
	icAccountStates,
	icInvoice,
	icSearch,
	icSearch2,
	icSupport,
	icSignOff,
	icPlus,
	icMinus,
	icTrash,
	icTrash2,
	icMarker,
	icTruck,
	icNext,
	icInvoiceDownload,
	icGuideDownload,
	icUserWithBack,
	icSend,
	icDownload,
	icDownload2,
	icEye,
	icEdit,
	icPhone,
	icShoppingCartClear,
	icUserHeadPhones,
	icHome,
	icCheck,
	imgBBVA,
	imgBCP,
	imgBN,
	imgCaja,
	imgIbk,
	icRequirement,
	icCalendar,
	icCalendar2,
	icClock,
	icBtuPrice,
	icDeliveryStep1,
	icDeliveryStep2,
	icDeliveryStep3,
	icDeliveryCar,
	icXInsideCircle,
	imgCalendar,
	imgClock,
	imgHomeOutline,
	icPhoneOutline,
	icDot,
	icArrowSubmenu,
	icArrowSubmenuLine,
	imgArrowSubmenuLine,
	imgArrowSubmenu,
	imgBTUSaleSuccess,
	icCapEnerjet,
	icInvitation,
	icWheel,
	imgBatteryLevel,
	imgButtonGame,
	imgScratchCover,
	imgScratchGameBg,
	imgScratchGameMini,
	imgSlotsGameBg,
	imgSlotsGameMini,
	imgWheelCenter,
	imgWheelFoot,
	imgWheelGameBg,
	imgWheelGameMini,
	imgWheelName,
	imgWheel,
	imgWheelPrize15p,
	imgWheelPrizeCup,
	imgWheelPrizeHincha,
	imgWheelPrizeJacket,
	imgWheelPrizeNothing,
	imgWheelPrizeTshirt,
};
